import { Ajax } from "../Common/Ajax";
import { CookieHelper } from "../Common/CookieHelper";
import { GlobalData } from "../Common/GlobalData";
import { ReportDateHelper, TemplateHelpers } from "../Common/KendoHelpers";

export class HeatMapModel {
    symbol: string | null = null;
    sumQtyOwn: number | null = null;
    totalGainLoss: number | null = null;
    totalGainLossPct: number | null = null;
    color: string | null = null;
}

export class HeatMap {
    private static readonly SWITCH_SORT_ORDER = 'switchSortOrder';
    private static readonly LISTVIEW = '#heatMapListView';

    private sortByTotalGainLoss = true;

    constructor(useAccount: boolean) {
        const account = useAccount ?
            CookieHelper.get(GlobalData.PORTFOLIO_ACCOUNT_SELECTOR_COOKIE) : null;

        this.initRadioButtons(account);
        this.getReportDate(account);
        this.createListView(account);
    }

    private initRadioButtons(account: string | null) {
        $('[name=' + HeatMap.SWITCH_SORT_ORDER + ']').on('change', (event: any) => {
            if (event.currentTarget.value == '1') {
                this.sortByTotalGainLoss = true;
            } else {
                this.sortByTotalGainLoss = false;
            }
            this.createListView(account);
        });
    }

    private getReportDate(account: string | null) {
        let url = GlobalData.URL_SUFFIX_PERSONAL_HEAT_MAP + '/reportDate';
        if (account) {
            url += '?account=' + account;
        }

        const success = (data: string | null) => {
            ReportDateHelper.showReportDate(data);
        };

        Ajax.invoke(url, 'GET', null, success);
    }

    private createListView(account: string | null) {
        let url = GlobalData.URL_SUFFIX_PERSONAL_HEAT_MAP +
            '?sortByTotalGainLoss=' + this.sortByTotalGainLoss;
        if (account) {
            url += '&account=' + account;
        }

        const success = (data: HeatMapModel[]) => {
            const listView = $(HeatMap.LISTVIEW).data('kendoListView');
            if (listView) {
                listView.destroy();
                $(HeatMap.LISTVIEW).empty();
            }

            let minGainLoss: number = Number.POSITIVE_INFINITY;
            let maxGainLoss: number = Number.NEGATIVE_INFINITY;

            for (const item of data) {
                if (!item?.totalGainLoss || !item?.totalGainLossPct) {
                    continue;
                }

                const totalGainLoss = this.sortByTotalGainLoss ?
                    item.totalGainLoss : item.totalGainLossPct;

                if (totalGainLoss < minGainLoss) {
                    minGainLoss = totalGainLoss;
                }
                if (totalGainLoss > maxGainLoss) {
                    maxGainLoss = totalGainLoss;
                }
            }
            for (const item of data) {
                if (!item?.totalGainLoss || !item?.totalGainLossPct) {
                    item.totalGainLoss = 0;
                    item.totalGainLossPct = 0;
                    item.color = 'white';
                    continue;
                }

                const totalGainLoss = this.sortByTotalGainLoss ?
                    item.totalGainLoss : item.totalGainLossPct;
                let hue: number;

                if (totalGainLoss >= 0) {
                    hue = Math.round(- 1 * totalGainLoss /
                        maxGainLoss * 100 + 255);
                    item.color = `rgb(0, ${hue}, 0)`;
                }
                else {
                    hue = Math.round(- 1 * totalGainLoss /
                        minGainLoss * 80 + 255);
                    item.color = `rgb(${hue}, 0, 0)`;
                }
            }

            $(HeatMap.LISTVIEW).kendoListView({
                dataSource: data,
                template: kendo.template(TemplateHelpers.getHeatMapTemplate())
            }).data('listView');
        };

        const error = (x: any) => {
            // TODO: notify.
        };

        Ajax.invoke(url, 'GET', null, success, error);
    }
}
